import { render, staticRenderFns } from "./SelectUserDialog.vue?vue&type=template&id=40c67a55&"
import script from "./SelectUserDialog.vue?vue&type=script&lang=js&"
export * from "./SelectUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports